<template>
  <tr
    :class="[
      failed
        ? 'even:bg-red-50 odd:bg-red-100 text-red-700'
        : 'even:bg-white odd:bg-gray-50 text-gray-900',
    ]"
  >
    <td class="px-4 py-4 text-sm align-top">
      <p class="break-words">{{ address }}</p>
      <ul>
        <li v-for="contact in trackingLog.contacts" :key="contact.id">
          <a
            role="button"
            class="text-gray-600 text-xs break-words underline"
            @click.prevent="showContact(contact.id)"
          >
            {{ contact.full_name }}
          </a>
        </li>
      </ul>
    </td>
    <td class="px-4 py-4 text-sm break-words align-top">
      <p>{{ status }}</p>
      <p class="max-w-lg text-xs mt-2">{{ trackingLog.error }}</p>
    </td>
    <td class="px-4 py-4 text-sm whitespace-nowrap align-top">
      {{ opened }} <span v-if="openedTimes">({{ openedTimes }})</span>
    </td>
    <td class="px-4 py-4 text-sm whitespace-nowrap align-top">
      <div class="flex flex-col gap-1 items-end">
        <ViewBouncesAction
          v-if="trackingLog.bounce_logs_count"
          :email-campaign-id="trackingLog.sender_id"
          :email-message-tracking-log-id="trackingLog.id"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import { capitalize } from 'lodash-es';
import ViewBouncesAction from './ViewBouncesAction.vue';

export default {
  components: {
    ViewBouncesAction,
  },
  props: {
    trackingLog: {
      type: Object,
      required: true,
    },
  },
  computed: {
    status() {
      const { status = '' } = this.trackingLog;

      return status ? capitalize(status) : 'N/A';
    },
    failed() {
      return this.trackingLog.status === 'FAILED';
    },
    address() {
      return this.trackingLog.to_address || 'N/A';
    },
    opened() {
      if (!this.trackingLog.open_logs_count) {
        return 'N/A';
      }

      return this.trackingLog.open_logs_count > 0 ? 'Yes' : 'No';
    },
    openedTimes() {
      const { open_logs_count: count } = this.trackingLog;
      if (typeof count === 'undefined') {
        return null;
      }

      const suffix = count > 1 ? 'times' : 'time';

      return `${count} ${suffix}`;
    },
  },
  methods: {
    showContact(contactId) {
      this.$modal.show({
        component: 'ContactModal',
        props: {
          contactId: contactId,
        },
        on: {
          'contact-deleted': () => {
            this.$emit('change');
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
